import { render } from "./CheckInRecordComp.vue?vue&type=template&id=335fabe2"
import script from "./CheckInRecordComp.vue?vue&type=script&lang=js"
export * from "./CheckInRecordComp.vue?vue&type=script&lang=js"
script.render = render

export default script
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});
